import React, { useState, useEffect } from "react";
import { fetchWithAuth } from "../utils/fetchWithAuth";
import {Link, useNavigate} from "react-router-dom";
import FeedbackForm from "../components/FeedbackForm";
import {useAuth} from "../contexts/authContext";

export default function InquiryPage() {
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [inquiries, setInquiries] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [showFeedback, setShowFeedback] = useState(false);
  const [userNickname, setUserNickname] = useState('');
  const { isLoggedIn, setIsLoggedIn, userEmail, setUserEmail } = useAuth();

  const loadInquiries = async () => {
    setLoading(true);
    const res = await fetchWithAuth("/inquiries/me");
    if (res.ok) {
      const data = await res.json();
      setInquiries(data);
    }
    setLoading(false);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("email");
    localStorage.removeItem("nickname");
    localStorage.removeItem("usage_count");
    localStorage.removeItem("daily_limit");
    setIsLoggedIn(false);
    setUserEmail("");
    alert("로그아웃 되었습니다.");
    navigate("/login");
  };

  useEffect(() => {
    const nickname = localStorage.getItem("nickname");
    if (nickname) setUserNickname(nickname);
  }, []);

  useEffect(() => {
    loadInquiries();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!title.trim() || !content.trim()) {
      alert("제목과 내용을 입력하세요.");
      return;
    }

    const res = await fetchWithAuth("/inquiries", {
      method: "POST",
      body: JSON.stringify({ title, content }),
    });
    if (res.ok) {
      alert("문의가 등록되었습니다.");
      setTitle("");
      setContent("");
      loadInquiries();
    } else {
      alert("문의 등록 실패");
    }
  };

  return (
       <div className="min-h-screen bg-gray-100 dark:bg-gray-900 text-white">
        <header
            className="w-full flex flex-col md:flex-row justify-between items-center px-4 py-4 border-b bg-white dark:bg-gray-800">
          <div className="text-center md:text-left mb-4 md:mb-0">
            <h1 className="text-xl font-bold text-blue-600 dark:text-blue-300">J_Universe</h1>

            <nav className="mt-2 text-sm">
              <Link to="/" className="hover:text-blue-400">J_Universe</Link>
              <span className="mx-2">|</span>
            </nav>
          </div>

          <div className="flex flex-col items-end gap-2 mt-4 md:mt-0">
            {isLoggedIn && (
                <div className="text-sm font-semibold text-green-300 text-center md:text-right w-full">
                  어서오세요, <span className="text-yellow-400">{userNickname}</span> 님
                </div>
            )}
            <div className="flex gap-2">
              {isLoggedIn ? (
                  <button
                      onClick={handleLogout}
                      className="px-4 py-2 text-sm font-semibold bg-red-500 text-white rounded-full">
                    Sign out
                  </button>
              ) : (
                  <Link
                      to="/login"
                      className="px-4 py-2 text-sm font-semibold bg-blue-500 text-white rounded-full">
                    Sign in
                  </Link>
              )}
               {!isLoggedIn && (
                <Link
                  to="/signup"
                  className="px-4 py-2 text-sm font-semibold text-white bg-green-500 rounded-full"
                >
                  Sign up
                </Link>
              )}
              {isLoggedIn && (
                <Link
                  to="/mypage"
                  className="px-4 py-2 text-sm font-semibold text-white bg-green-500 rounded-full"
                >
                  MyPage
                </Link>
              )}
            </div>
          </div>
        </header>
        <div className="p-6 text-white bg-gray-900 min-h-screen">
            <div className="max-w-2xl mx-auto p-4 text-white">
            <h1 className="text-2xl font-bold mb-4">1:1 문의</h1>

            {/* 문의 작성 */}
            <form onSubmit={handleSubmit} className="mb-6 bg-gray-800 p-4 rounded-lg shadow">
              <input
                type="text"
                placeholder="제목"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                className="w-full p-2 mb-2 text-black rounded"
                required
              />
              <textarea
                placeholder="문의 내용"
                value={content}
                onChange={(e) => setContent(e.target.value)}
                className="w-full p-2 mb-2 text-black rounded"
                rows="5"
                required
              />
              <button
                type="submit"
                className="bg-blue-500 px-4 py-2 rounded hover:bg-blue-600"
              >
                제출
              </button>
            </form>

            {/* 문의 목록 */}
            <h2 className="text-xl font-semibold mb-2">내 문의 목록</h2>
            {loading ? (
              <div>로딩 중...</div>
            ) : inquiries.length === 0 ? (
              <p>등록된 문의가 없습니다.</p>
            ) : (
              inquiries.map((inq) => (
                <div key={inq.id} className="border-b border-gray-700 py-3">
                  <div className="font-bold">{inq.title}</div>
                  <div className="text-sm">{inq.content}</div>
                  {inq.answer && (
                    <div className="mt-1 text-green-400">[답변] {inq.answer}</div>
                  )}
                  <div className="text-xs text-gray-400">
                    {new Date(inq.created_at).toLocaleString()}
                  </div>
                </div>
              ))
            )}
          </div>
        </div>

 </div>

  );
}
